import apiConfig from './APIConfig';

const baseURL = apiConfig.appConfig.apitsda;
//const baseURLSysadmin = apiConfig.appConfig.apisysadmin;

export default baseURL;
